import React from 'react';
import { Navigate } from 'react-router-dom';

import { DataPipelineList } from 'packages/dataPipeline/ui/list/DataPipelineList';
import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';

export const DataPipelineListRoute = () => {
  const flags = useFeatureFlags();
  const { user } = useUserAuthOrThrow();

  // we shouldnt reach here if flag is not enabled
  if (!flags.showDataPipeline) {
    return <Navigate to="/" />;
  }

  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/" />;
      }}
    >
      <DataPipelineList organizationId={user.organizationId} />
    </RouteErrorBoundary>
  );
};
